import { Input } from "antd";
import React, { useContext, useEffect, useState } from "react";
import SaveButton from "../SaveButton";
import TrackerModeSwitch from "../TrackerModeSwitch";
import { TrackerContext } from "../utils/types";
import { LiveTimer } from "./LiveTimer";
import { ManualTimeFields } from "./ManualTimeFields";
import { ProjectSelect } from "./ProjectSelect";

export const TrackerRow: React.FC = () => {
  const {
    formData,
    setFormData,
    isTracking,
    typeOfTracking,
    updateCurrentSessionDescription,
    trackerLoading,
  } = useContext(TrackerContext);

  const [descriptionValue, setDescriptionValue] = useState(
    formData.description ?? "",
  );

  useEffect(() => {
    setDescriptionValue(formData.description ?? "");
  }, [formData.description]);

  const handleDescriptionBlur = () => {
    if (isTracking && descriptionValue !== formData.description) {
      updateCurrentSessionDescription(descriptionValue);
    } else if (!isTracking) {
      setFormData((prev) => ({ ...prev, description: descriptionValue }));
    }
  };

  return (
    <div
      style={{
        width: "100%",
        border: "1px solid #d9d9d9",
        borderRadius: 6,
        backgroundColor: "white",
        boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
        padding: "6px 8px",
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* Description */}
      <Input
        style={{
          flex: 1,
          minWidth: 120,
          border: "1px solid #d9d9d9",
          boxShadow: "none",
          fontSize: 15,
        }}
        placeholder="What are you working on?"
        disabled={trackerLoading && isTracking}
        value={descriptionValue}
        onChange={(e) => setDescriptionValue(e.target.value)}
        onBlur={handleDescriptionBlur}
        onPressEnter={handleDescriptionBlur}
        maxLength={3000}
      />

      {/* Project */}
      <ProjectSelect />

      {/* Time fields */}
      {typeOfTracking === "Manual" ? <ManualTimeFields /> : <LiveTimer />}

      {/* Save / Start / Stop */}
      <div style={{ padding: "0 8px", flexShrink: 0 }}>
        <SaveButton />
      </div>

      {/* Mode switch */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingRight: 6,
          flexShrink: 0,
        }}
      >
        <TrackerModeSwitch />
      </div>
    </div>
  );
};
